// extracted by mini-css-extract-plugin
export var auto = "_3x-1";
export var spinner = "_3x-0";